import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApiRequestError, ApiRequestProgress, ApiRequestSucceed } from '../saga/api/actions';
import { IApiState, IApiStateEntry } from '../saga/api/types';

const apiSlice = createSlice({
  name: 'api',
  initialState: {} as IApiState,
  reducers: {
    setApiState: (state, { payload }: PayloadAction<{ key: string; state?: IApiStateEntry }>) => {
      if (!payload.state) {
        delete state[payload.key];
      } else {
        state[payload.key] = payload.state;
      }
    },
  },
  extraReducers(builder) {
    builder
      .addCase(ApiRequestProgress, (state, { payload }) => {
        state[payload.key] = {
          status: 'progress',
          timestamp: Date.now(),
        };
      })
      .addCase(ApiRequestError, (state, { payload }) => {
        state[payload.key] = {
          status: 'rejected',
          error: payload.error,
          timestamp: Date.now(),
          execActions: true,
        };
      })
      .addCase(ApiRequestSucceed, (state, { payload }) => {
        state[payload.key] = {
          status: 'succeed',
          timestamp: Date.now(),
          execActions: true,
        };
      });
  },
});

export const { setApiState } = apiSlice.actions;
export default apiSlice.reducer;
